import cn from 'classnames';
import { ActionButtonType } from '../types';
import { Button, ButtonProps } from './button';
import styles from './action-button.module.scss';

type BaseProps = {
  action: ActionButtonType;
  text?: string;
};

export type ActionButtonProps = BaseProps & Omit<ButtonProps, 'children'>;

/**
 * Action button
 * @param action
 * @param text
 */
export const ActionButton = ({
  action,
  className,
  text = action === ActionButtonType.accept ? 'Принять' : 'Отказаться',
  ...otherProps
}: ActionButtonProps) => {
  if (action === ActionButtonType.accept) {
    return (
      <Button {...otherProps} className={cn(className, styles.accept)}>
        {text}
      </Button>
    );
  }

  return (
    <Button {...otherProps} className={cn(className, styles.decline)}>
      {text}
    </Button>
  );
};
